export let appToDo = "LtTHo";
export default {appToDo};